// Should stay in sync with tasksDueNotificationUnionGraphqlTypes.mjs

export const TASKS_DUE_NOTIFICATION_UNION_GRAPHQL_TYPES = {
  OBSERVATION_REPORT_NOTIFICATION_TYPENAME: 'ObservationReportNotification'
};
